/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: USERS.AuthUserInfo } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: Boolean(currentUser?.permissions?.includes('role:write')),
  };
}
